import { COMPONENT_VALUE_TYPES as types, REGIONS } from 'shared/constants';

const propsSchema = [
  {
    type: types.ENUM,
    key: 'region',
    label: 'Region',
    options: REGIONS
  },
  {
    type: types.DATETIME,
    key: 'start_date',
    label: 'Event Start Date'
  },
  {
    type: types.DATETIME,
    key: 'end_date',
    label: 'Event End Date'
  },
  {
    type: types.TEXT,
    key: 'event_name',
    label: 'Event Name'
  },
  {
    type: types.TEXT,
    key: 'event_description',
    label: 'Event Description'
  },
  {
    type: types.TEXT,
    key: 'event_location',
    label: 'Event Location'
  },
];

const defaultProps = {
  region: 'US',
  start_date: '',
  end_date: '',
  event_name: 'Event Name',
  event_description: 'Event Description',
  event_location: 'Event Location',
};

export default {
  title: 'Add to Calendar',
  id: 'AddToCalendar',
  propsSchema,
  defaultProps
};
